import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { mapMicrocopyHeaders } from "@lib/utils/microcopyhelpers";

export const changePasswordProfileWrapper = "change-password-profile-wrapper";

export const useGetHeaders = () => {
    const { getMultiple } = useMicrocopy();

    const namedMC = {
        newPassword: CommonCMS.profile.newPassword,
        currentPassword: CommonCMS.profile.currentPassword,
        confirmPassword: CommonCMS.profile.confirmPassword,
        changePassword: CommonCMS.profile.changePassword,
        label: CommonCMS.password,
        passwordRules: CommonCMS.passwordRules,
        passwordRulesError: CommonCMS.error.passwordRules,
        requiredFieldError: CommonCMS.error.requiredFieldError,
        passwordsDontMatch: CommonCMS.error.passwordsDontMatch,
        savePassword: CommonCMS.button.savePassword,
        cancel: CommonCMS.button.cancel,
        edit: CommonCMS.edit,
        wrongPassword: CommonCMS.error.wrongPassword,
        passwordWasUpdated: CommonCMS.profile.passwordWasUpdated,
        redirectToLogIn: CommonCMS.profile.redirectToLogIn,
    };

    const microcopies = getMultiple(CommonCMS.page, Object.values(namedMC));

    return mapMicrocopyHeaders(namedMC, microcopies);
};
